import React from "react"
import { HStack, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { asNumber } from "utilities/strings"

const ViewsCount = ({ label, count }: { label: string, count: number }) => (
  <HStack spacing={2} fontSize="lg" whiteSpace="nowrap">
    <Icon icon="eye" size={5} color="gray.600" />
    <Text as="span">{label}:</Text>
    <Text as="span" fontWeight="bold">{asNumber(count)}</Text>
  </HStack>
)

export default ViewsCount
